/** Convert a CSS-style linear-gradient angle (degrees, 0deg =
 *  bottom-to-top) into a unit vector (dx, dy) on a normalized
 *  bounding box where (0,0) is top-left and (1,1) is bottom-right.
 *  The returned vector points along the gradient direction; we
 *  use it to place gradient stops at `(0.5 - dx, 0.5 - dy)` and
 *  `(0.5 + dx, 0.5 + dy)` so the gradient runs through the box
 *  center.
 *
 *  CSS / Fabric coordinate system has Y increasing downward, so
 *  "bottom-to-top" means dy < 0. */
export function linearAngleToUnitVector(angleDeg: number): { dx: number; dy: number } {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    dx: Math.sin(rad) * 0.5,
    dy: -Math.cos(rad) * 0.5,
  };
}

/** Inverse of `linearAngleToUnitVector`: derive the CSS angle
 *  (0–360, normalized) from a gradient vector — the vector goes
 *  from start stop to end stop. Used when reading a Fabric
 *  Gradient back into the editor's `LinearGradientValue` for the
 *  picker. The full vector magnitude doesn't matter; only the
 *  direction. */
export function unitVectorToLinearAngle(dx: number, dy: number): number {
  // atan2(dx, -dy) inverts the dx = sin, dy = -cos pair from the
  // forward conversion. Add 360 + mod 360 to normalize negative
  // results into [0, 360).
  return ((Math.atan2(dx, -dy) * 180) / Math.PI + 360) % 360;
}
